import type { ProductDocument } from '@ab-core/graphql/dist';
import type { CableSnap, PositionPriceObject } from '@ab-core/graphql/dist/index';
import { makeVar, useReactiveVar } from '@apollo/client';
import type { AddToListsOrCartsModalProductStatePropType, ProductStoreType, StateType } from './types';

const _state: StateType = {
    cartOrShoppingListModal: makeVar<AddToListsOrCartsModalProductStatePropType | undefined>(undefined),
    showCalculator: makeVar<boolean>(false),
    showCableSnap: makeVar<boolean>(false),
    cableSnapSku: makeVar<string>(''),
    cableSnapData: makeVar<Array<CableSnap>>([]),
    showCarOrShoppingListModal: makeVar<boolean>(false),
    showContactPersonModal: makeVar<boolean>(false),
    showItShopModal: makeVar<boolean>(false),
    showSuccessorModal: makeVar<boolean>(false),
    successorSku: makeVar<string>(''),
    quantity: makeVar<number>(1),
    price: makeVar<PositionPriceObject | undefined>(undefined),
    product: makeVar<ProductDocument | undefined>(undefined),
    showOxomi: makeVar<boolean>(false)
};

export const productStore: ProductStoreType = {
    getters: {
        useCartOrShoppingListModal: () => useReactiveVar(_state.cartOrShoppingListModal),
        useShowCalculator: () => useReactiveVar(_state.showCalculator),
        useShowCableSnap: () => useReactiveVar(_state.showCableSnap),
        useCableSnapSku: () => useReactiveVar(_state.cableSnapSku),
        useCableSnapData: () => useReactiveVar(_state.cableSnapData),
        useShowCartOrShoppingListModal: () => useReactiveVar(_state.showCarOrShoppingListModal),
        useShowContactPersonModal: () => useReactiveVar(_state.showContactPersonModal),
        useShowItShopModal: () => useReactiveVar(_state.showItShopModal),
        useShowSuccessorModal: () => useReactiveVar(_state.showSuccessorModal),
        useSuccessorSku: () => useReactiveVar(_state.successorSku),
        useQuantity: () => useReactiveVar(_state.quantity),
        usePrice: () => useReactiveVar(_state.price),
        useProduct: () => useReactiveVar(_state.product),
        useShowOxomi: () => useReactiveVar(_state.showOxomi)
    },

    setters: {
        setCartOrShoppingListModal: (product) => _state.cartOrShoppingListModal(product),
        setShowCalculator: (show) => _state.showCalculator(show),
        setShowCableSnap: (cableSnap) => _state.showCableSnap(cableSnap),
        setCableSnapSku: (cableSnapSku) => _state.cableSnapSku(cableSnapSku),
        setCableSnapData: (cableSnapData) => _state.cableSnapData(cableSnapData),
        setShowCartOrShoppingListModal: (show) => _state.showCarOrShoppingListModal(show),
        setShowContactPersonModal: (show) => _state.showContactPersonModal(show),
        setShowItShopModal: (show) => _state.showItShopModal(show),
        setShowSuccessorModal: (show) => _state.showSuccessorModal(show),
        setSuccessorSku: (sku) => _state.successorSku(sku),
        setQuantity: (quantity) => _state.quantity(quantity),
        setPrice: (price) => _state.price(price),
        setProduct: (product) => _state.product(product),
        setShowOxomi: (show: boolean) => _state.showOxomi(show)
    }
};
